module.exports = __webpack_public_path__ + "static/media/wf.850539e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/wf.svg
// module id = 288
// module chunks = 0